import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { useLockAllCatalogItemsModel } from '@webapp/modules/purchasing/features/lock-all-catalog-items/models'
import messages from './messages'

export const useLockAllCatalogItemsPresenter = () => {
  const { lockAllCatalogItems, isLoading } = useLockAllCatalogItemsModel()
  const intl = useProcurifyIntl()

  const lockAll = async (): Promise<void> => {
    try {
      await lockAllCatalogItems()

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage),
      })
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ||
          intl.formatMessage(messages.errorMessage),
      })

      // Re-throw so the consuming Feature Set owns the outcome (e.g. whether
      // its confirmation modal closes) — the toast above is this presenter's
      // whole error responsibility.
      throw error
    }
  }

  return {
    commands: {
      lockAll,
    },
    states: {
      isSaving: isLoading,
    },
  }
}
